/**
 * The single writer of `document.title`: the app's page title, unless the
 * privacy curtain masks it. Null until first needed, then seeded from the
 * static `<title>`, so an app that never sets a page title keeps its own.
 */
let pageTitle: string | null = null;
let titleMask: string | null = null;

function applyDocumentTitle() {
  pageTitle ??= document.title;
  document.title = titleMask ?? pageTitle;
}

/** Sets the app's page title; it shows once no mask is up. */
export function setDocumentPageTitle(title: string) {
  pageTitle = title;
  applyDocumentTitle();
}

/** Shows `mask` in place of the page title, or the page title again on null. */
export function setDocumentTitleMask(mask: string | null) {
  titleMask = mask;
  applyDocumentTitle();
}
